/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { brandingCreate } from "../../funcs/brandingCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateBrandRequest$inboundSchema,
};

export const tool$brandingCreate: ToolDefinition<typeof args> = {
  name: "branding-create",
  description: `Create brand properties for the specified account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/branding.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await brandingCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
